const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="prototype-articles-example">
  <div class="articles">
    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 3, this.source)(this.env, (context.has(`feed`) ? context.get(`feed`) : null), `items`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`article`] = __value__;
                    this.echo(`      <article>
        <header>
          <h2>
            <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 7, this.source)(this.env, context.get(`article`), `url`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
              `);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 8, this.source)(this.env, context.get(`article`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
            </a>
          </h2>
        </header>
        <p>
          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(13, this.source)(...[this.env, this.env.getFilter('replace').traceableCallable(13, this.source)(...[this.traceableMethod(this.getAttribute, 13, this.source)(this.env, context.get(`article`), `date_published`, new Map([]), `any`, false, false, false), new Map([[`Z`, ``]])]), `F j, Y`]), `html`, null, true]));
                    this.echo(`
        </p>
        `);
                    if (this.traceableMethod(this.getAttribute, 15, this.source)(this.env, context.get(`article`), `image`, new Map([]), `any`, false, false, false)) {
                        this.echo(`          `);
                        this.echo(this.include(context, this.source, this.loadTemplate(`6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, 16, 66), new Map([[`class`, `o-embed--wide`]]), true, false, 16));
                        this.echo(`        `);
                    }
                    this.echo(`        <p>
          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 25, this.source)(this.env, context.get(`article`), `summary`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
        </p>
        <footer>
          <p>
            <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(29, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 29, this.source)(this.env, this.traceableMethod(this.getAttribute, 29, this.source)(this.env, context.get(`article`), `author`, new Map([]), `any`, false, false, false), `url`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
              `);
                    this.echo(this.env.getFilter('escape').traceableCallable(30, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 30, this.source)(this.env, this.traceableMethod(this.getAttribute, 30, this.source)(this.env, context.get(`article`), `author`, new Map([]), `any`, false, false, false), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
            </a>
          </p>
          `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, 33, 67), undefined, true, false, 33));
                    this.echo(`        </footer>
      </article>
    `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('article');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`    <div class="essentials">
      <h2>Essentials</h2>
      <p>Frequently-cited posts we’re particularly proud of.</p>
      <ul>
        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`essentials`) ? context.get(`essentials`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`article`] = __value__;
                    this.echo(`          <li>
            <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(47, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 47, this.source)(this.env, context.get(`article`), `url`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
              `);
                    this.echo(this.env.getFilter('escape').traceableCallable(48, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 48, this.source)(this.env, context.get(`article`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
            </a>
          </li>
        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('article');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      </ul>
    </div>
    <div class="topics">
      <h2>Topics</h2>
      <ul>
        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.env.getFilter('slice').traceableCallable(57, this.source)(...[this.env, (context.has(`topics`) ? context.get(`topics`) : null), 0, 7]));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`topic`] = __value__;
                    this.echo(`          <li>
            <a href="#">
              `);
                    this.echo(this.env.getFilter('escape').traceableCallable(60, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 60, this.source)(this.env, context.get(`topic`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
              (`);
                    this.echo(this.env.getFilter('escape').traceableCallable(61, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 61, this.source)(this.env, context.get(`topic`), `count`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(` articles)
            </a>
          </li>
        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('topic');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      </ul>
      <p>
        <a href="#">
          All topics
        </a>
      </p>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, ``);
            }
        }],
        [66, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, 16);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(20, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 20, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `image`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
            `);
            }

            getTemplateName() {
                return `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, ``);
            }
        }],
        [67, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, 33);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(35, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 35, this.source)(this.env, this.traceableMethod(this.getAttribute, 35, this.source)(this.env, (context.has(`article`) ? context.get(`article`) : null), `author`, new Map([]), `any`, false, false, false), `avatar`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
            `);
            }

            getTemplateName() {
                return `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702');

let template = env.loadTemplate('6f3a6a32a686db0c801787580905888baab7dd1367a864033be9001d58484702');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/articles/example/example.twig", args: context }
     );
     return rendered;;
};